import { useMIPManageContext } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/MIPManageContext';
import { NewLeaverInviteTemplateFormValues } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Modals/NewLeaversModal/useNewLeaversModalController';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { useEffect } from 'react';
import { useForm, UseFormReturn } from 'react-hook-form';

export enum INVITATION_PREVIEW_INPUTS_FORM {
	EMAIL_BODY_TEXT = 'email_body_text',
}

interface IUseNewLeaverController {
	inviteTemplateForm: UseFormReturn<NewLeaverInviteTemplateFormValues>;
}

export const useNewLeaversInvitationPreviewController = (
	useNewLeaverController: IUseNewLeaverController
) => {
	const tMipManage = useTranslationMipManage();
	const mipManageController = useMIPManageContext();
	const { inviteTemplateForm } = useNewLeaverController;

	const defaultTemplate = tMipManage('new_leaver.template', {
		entityName: mipManageController.mipData?.entityName,
	});

	const invitationText = inviteTemplateForm?.getValues('invitationText');
	const selectedEmailTemplate = invitationText ?? defaultTemplate;
	const invitationPreviewForm = useForm({
		mode: 'onChange',
		reValidateMode: 'onChange',
		defaultValues: {
			[INVITATION_PREVIEW_INPUTS_FORM.EMAIL_BODY_TEXT]: selectedEmailTemplate,
		},
	});

	useEffect(() => {
		const newEmailBodyText = invitationPreviewForm.getValues(
			INVITATION_PREVIEW_INPUTS_FORM.EMAIL_BODY_TEXT
		);
		if (!newEmailBodyText) {
			return;
		}
		if (newEmailBodyText === defaultTemplate) {
			return;
		}
		inviteTemplateForm.setValue('invitationText', newEmailBodyText);
	}, [invitationPreviewForm.getValues(INVITATION_PREVIEW_INPUTS_FORM.EMAIL_BODY_TEXT)]);

	return {
		invitationPreviewForm,
	};
};
